import styled, { css } from "styled-components";

const btnTypes = {
  outline: css`
    border: 1px solid;
    border-color: ${({ theme, color }) =>
      theme.colors?.[color] ?? "transparent"};
    color: ${({ theme, color }) => theme.colors?.[color] ?? "inherit"};
    border-radius: 5px;
    padding: 12px;
    font-size: 1.1rem;
  `,
  filled: css`
    background-color: ${({ theme, color }) =>
      theme.colors?.[color] ?? "transparent"};
    color: #fff;
    border: 1px solid transparent;
    border-radius: 5px;
    padding: 12px;
    font-size: 1.1rem;
  `,
  link: css`
    color: ${({ theme, color }) => theme.colors?.[color] ?? "inherit"};
    padding: 0;
  `,
  icon: css`
    width: ${({ size = 0 }) => `${size}px`};
    height: ${({ size = 0 }) => `${size}px`};
    background: ${({ theme, bgColor }) =>
      theme.colors?.[bgColor] ?? "transparent"};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  `,
};

const Button = styled.button`
  display: inline-block;
  ${({ block }) => (block ? `width: 100%` : "")};
  font-family: inherit;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0;
  font-size: inherit;

  ${({ styleType }) => (styleType ? btnTypes?.[styleType] ?? "" : "")}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default Button;
